import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";

// Components
import LanguageGate from "./components/LanguageGate";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SocialProof from "./components/SocialProof";
import Experience from "./components/Experience";
import RooftopEmotion from "./components/RooftopEmotion";
import PartyRoom from "./components/PartyRoom";
import BBQ from "./components/BBQ";
import WhoItsFor from "./components/WhoItsFor";
import Testimonials from "./components/Testimonials";
import Pricing from "./components/Pricing";
import OperatingHours from "./components/OperatingHours";
import FAQ from "./components/FAQ";
import Location from "./components/Location";
import BookingFunnel from "./components/BookingFunnel";
import Contact from "./components/Contact";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import MobileStickyBar from "./components/MobileStickyBar";
import FloatingCallButton from "./components/FloatingCallButton";

const LandingPage = () => {
  const { showGate } = useLanguage();

  if (showGate) {
    return <LanguageGate />;
  }

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        <Hero />
        <SocialProof />
        <Experience />
        <RooftopEmotion />
        <PartyRoom />
        <BBQ />
        <WhoItsFor />
        <Testimonials />
        <Pricing />
        <OperatingHours />
        <FAQ />
        <Location />
        <BookingFunnel />
        <Contact />
        <Gallery />
      </main>
      <Footer />
      <MobileStickyBar />
      <FloatingCallButton />
      {/* Bottom padding for mobile sticky bar */}
      <div className="lg:hidden h-16" />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;